import { render, staticRenderFns } from "./SetFields.vue?vue&type=template&id=a874f1d2&"
import script from "./SetFields.vue?vue&type=script&lang=js&"
export * from "./SetFields.vue?vue&type=script&lang=js&"
import style0 from "./SetFields.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports